import http from '../general/httpService'
import { apiEndpoint } from '../../constants/config.json'

export function fetchAboutUsHeader() {
  const fullApiEndpoint = apiEndpoint + '/aboutmanagement/api/fetch_about_us'
  return http.get(fullApiEndpoint)
}
